<div class = "container">
    <div class="loading-overlay" *ngIf="loading">
        <mat-progress-spinner mode="indeterminate" diameter="40" strokeWidth="3"></mat-progress-spinner>
    </div>

    <form class = "card-form"  [formGroup]="motorForm" (ngSubmit)="submitForm()" novalidate>
        <div class="blue-top"></div>
        <div class="card-section top-section ">
            <h1><b>{{pageHeading}}</b></h1>
            <h2>{{pageSubheading}}</h2>

            <mat-form-field appearance="outline" class="form-select" appFullYearDateFormat>
                <mat-label class="form-select-placeholder-unselected">{{accidentDateLabel}}</mat-label>
                <input matInput  [min]="minDate" [max]="maxDate" [matDatepicker]="picker" readonly="true" (click)="picker.open()" formControlName="accidentDate">
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker >
                </mat-datepicker>
            </mat-form-field>

            <mat-form-field appearance="outline" class="form-select">
                <mat-label class="form-select-placeholder-unselected" >{{accidentTimeLabel}}</mat-label>
                <input matInput type="time" formControlName="accidentTime" (blur)="logErrors()">
                <mat-error *ngIf="formErrors['accidentTime']">{{formErrors['accidentTime']}}</mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="form-select">
                <mat-label class="form-select-placeholder-unselected" >{{accidentLocationLabel}}</mat-label>
                <input matInput formControlName="accidentLocation" (blur)="logErrors()">
                <mat-error *ngIf="formErrors['accidentLocation']">{{formErrors['accidentLocation']}}</mat-error>
            </mat-form-field>

            <p *ngIf="claim === 'fire' || claim === 'flood' ">
                {{vehicleInUseQuestion}}
            </p>
            <section class="row-div modified_checkbox" formGroupName="vehicleInUse"
              *ngIf="claim === 'fire' || claim === 'flood' ">
                <div class="row-inner-div row-inner-div-left">
                    <mat-checkbox formControlName="yes" (change)="onNdioChange()">{{yesText}}</mat-checkbox>
                </div>
                <div class="row-inner-div row-inner-div-right">
                    <mat-checkbox formControlName="no" (change)="onLaChange()">{{noText}}</mat-checkbox>
                </div>
            </section>

            <mat-form-field
              appearance="outline"
              class="form-select"
              *ngIf="motorForm.controls['vehicleInUse'].controls['yes'].value === true || 
                !(claim === 'fire' || claim === 'flood')" >
                <mat-label class="form-select-placeholder-unselected" >{{roadSurfaceLabel}}</mat-label>
                <mat-select formControlName="roadSurface"  panelClass="form-select-popup" (blur)="logErrors()">
                    <mat-option class="form-option" [value]="roadSurface" *ngFor="let roadSurface of RoadSurfaces">
                        {{roadSurface}}
                    </mat-option>
                </mat-select>
                <mat-error *ngIf="formErrors['roadSurface']">{{formErrors['roadSurface']}}</mat-error>
            </mat-form-field>

            <mat-form-field
              appearance="outline"
              class="form-select"
              *ngIf="motorForm.controls['vehicleInUse'].controls['yes'].value === true || 
                !(claim === 'fire' || claim === 'flood')" >
                <mat-label class="form-select-placeholder-unselected" >{{accidentSpeedLabel}}</mat-label>
                <input matInput maxlength="3" formControlName="accidentSpeed" (blur)="logErrors()">
                <mat-error *ngIf="formErrors['accidentSpeed']">{{formErrors['accidentSpeed']}}</mat-error>
            </mat-form-field>
            <mat-form-field
              appearance="outline"
              class="form-select"
              *ngIf="motorForm.controls['vehicleInUse'].controls['yes'].value === true || 
               !(claim === 'fire' || claim === 'flood')" >
                <mat-label class="form-select-placeholder-unselected" >{{visibilityLabel}}</mat-label>
                <mat-select formControlName="visibility"  panelClass="form-select-popup" (blur)="logErrors()">
                    <mat-option class="form-option" [value]="_visibility" *ngFor="let _visibility of VisibilityOptions">
                        {{_visibility}}
                    </mat-option>
                </mat-select>
                <mat-error *ngIf="formErrors['visibility']">{{formErrors['visibility']}}</mat-error>
            </mat-form-field>
            <mat-form-field
              appearance="outline"
              class="form-select"
              *ngIf="motorForm.controls['vehicleInUse'].controls['yes'].value === true || 
              !(claim === 'fire' || claim === 'flood')" >
                <mat-label class="form-select-placeholder-unselected" >{{lightsShowingLabel}}</mat-label>
                <textarea matInput formControlName="lightsShowing" style="height: 70px;" (blur)="logErrors()"></textarea>
                <mat-error *ngIf="formErrors['lightsShowing']">{{formErrors['lightsShowing']}}</mat-error>
            </mat-form-field>
            <mat-form-field
              appearance="outline"
              class="form-select"
              *ngIf="motorForm.controls['vehicleInUse'].controls['yes'].value === true || 
              !(claim === 'fire' || claim === 'flood')" >
                <mat-label class="form-select-placeholder-unselected" >{{driverWarningLabel}}</mat-label>
                <textarea matInput formControlName="driverWarning" style="height: 70px;" (blur)="logErrors()"></textarea>
                <mat-error *ngIf="formErrors['driverWarning']">{{formErrors['driverWarning']}}</mat-error>
            </mat-form-field>
            <mat-form-field
              appearance="outline"
              class="form-select"
              *ngIf="motorForm.controls['vehicleInUse'].controls['yes'].value === true || 
              !(claim === 'fire' || claim === 'flood')" >
                <mat-label class="form-select-placeholder-unselected" >{{weatherLabel}}</mat-label>
                <mat-select formControlName="weather"  panelClass="form-select-popup" (blur)="logErrors()">
                    <mat-option class="form-option" [value]="weatherOption" *ngFor="let weatherOption of WeatherOptions">
                        {{weatherOption}}
                    </mat-option>
                </mat-select>
                <mat-error *ngIf="formErrors['weather']">{{formErrors['weather']}}</mat-error>
            </mat-form-field>

            <mat-form-field
              appearance="outline"
              class="form-select"
              *ngIf="motorForm.controls['vehicleInUse'].controls['yes'].value === true || 
              !(claim === 'fire' || claim === 'flood')" >
                <textarea matInput placeholder={{purposeAccidentLabel}} formControlName="purposeAccident" style="height: 70px;" (blur)="logErrors()"></textarea>
                <mat-error *ngIf="formErrors['purposeAccident']">{{formErrors['purposeAccident']}}</mat-error>
            </mat-form-field>
        </div>

        <div class="card-section bottom-section">
            <h2>{{policeInfoSubheading}}</h2>

            <p>{{policeQuestion}}</p>
            <section class="row-div modified_checkbox" formGroupName="policeTookParticulars">
                <div class="row-inner-div row-inner-div-left">
                    <mat-checkbox formControlName="yes" (change)="onYesChange()">{{yesText}}</mat-checkbox>
                    
                </div>
                <div class="row-inner-div row-inner-div-right">
                    <mat-checkbox formControlName="no" (change)="onNoChange()">{{noText}}</mat-checkbox>
                </div>
            </section>
            <mat-error *ngIf="formGroupErrors['policeTookParticulars']">{{formGroupErrors['policeTookParticulars']}}</mat-error>

            <div *ngIf="motorForm.controls['policeTookParticulars'].controls['yes'].value === true" class="width-100pc">
                <mat-form-field appearance="outline" class="form-select">
                    <mat-label class="form-select-placeholder-unselected" >{{constableNumLabel}}</mat-label>
                    <input matInput formControlName="constableNum" (blur)="logErrors()">
                    <mat-error *ngIf="formErrors['constableNum']">{{formErrors['constableNum']}}</mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" class="form-select">
                    <mat-label class="form-select-placeholder-unselected" >{{policeStationLabel}}</mat-label>
                    <input matInput formControlName="policeStation" (blur)="logErrors()">
                    <mat-error *ngIf="formErrors['policeStation']">{{formErrors['policeStation']}}</mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" class="form-select">
                    <textarea matInput placeholder={{driverStatementLabel}} (blur)="logErrors()" formControlName="driverStatement" style="height: 70px;"></textarea>
                    <mat-error *ngIf="formErrors['driverStatement']">{{formErrors['driverStatement']}}</mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" class="form-select">
                    <textarea matInput placeholder={{ownerStatementLabel}} (blur)="logErrors()" formControlName="ownerStatement" style="height: 70px;"></textarea>
                    <mat-error *ngIf="formErrors['ownerStatement']">{{formErrors['ownerStatement']}}</mat-error>
                </mat-form-field>
            </div>

            <div class="row-div margin-bottom-40 margin-top-30">
                <button mat-stroked-button type="button" (click)="confirmCancel()">
                    <span class="button-text">{{cancelText}}</span>
                </button>
                <button mat-button type="submit" [disabled]="!motorForm.valid">
                    <span class="button-text">{{saveText}}</span>
                </button>
            </div>

        </div>
    </form>
</div>
